<template>
  <v-container id="eventScheduleCompetitions" class="d-none d-print-inline">
    <template v-if="hasCompetitionsForRegistrationOnly">
      <v-row>
        <v-col>
          <h3 style="font-size: 16px">
            {{
              $t(
                "events:EventPage.registrationCompetitionsSection.heading",
                "Entries"
              )
            }}
          </h3>
        </v-col>
      </v-row>

      <EventCompetitions
        v-bind="$attrs"
        for-registration-competitions-only
        :event="event"
        :index="0"
        force-desktop
      >
        <template #subheading>
          {{
            $t(
              "events:EventPage.registrationCompetitionsSection.subheading",
              "List of events for entries"
            )
          }}
        </template>

        <template #competitions-column>
          {{
            $t(
              "events:EventPage.registrationCompetitionsSection.registrationCompetition.column",
              "Event"
            )
          }}
        </template>
        <template #judgments-column>
          {{
            $t(
              "events:EventPage.registrationCompetitionsSection.level.column",
              "Level"
            )
          }}
        </template>
        <template #prizes-column>
          {{
            $t(
              "events:EventPage.registrationCompetitionsSection.prizes.column",
              "Prizes"
            )
          }}
        </template>
        <template #openFor-column>
          {{
            $t(
              "events:EventPage.registrationCompetitionsSection.openFor.column",
              "Open for"
            )
          }}
        </template>
        <template #registered-column>
          {{
            $t(
              "events:EventPage.registrationCompetitionsSection.numberOfEntries.column",
              "Number of entries"
            )
          }}
        </template>
        <template #fees-column>
          {{
            $t(
              "events:EventPage.registrationCompetitionsSection.feesAndConditions.column",
              "Fees and conditions "
            )
          }}
        </template>
      </EventCompetitions>

      <AppShowCompetitionTagExplanations :competitions="event.competitions" />
    </template>

    <template v-if="canAdd || hasNormalCompetitions">
      <v-row class="d-print-none">
        <v-col>
          <h3 style="font-size: 16px">
            {{
              $t("events:EventPage.CompetitionsSection.label", "Competitions")
            }}
          </h3>
        </v-col>
      </v-row>

      <div
        v-if="canAdd || (event.competitions.length && event.scheduleVisible)"
      >
        <EventRegistrationsLimited :event="event">
          <template #additionals><div class="d-print-none"></div></template>
        </EventRegistrationsLimited>

        <EventCompetitions
          v-for="([day], i) in competitionsGroupedByDay"
          :key="i"
          v-bind="$attrs"
          :competition-day="day"
          :index="i"
          :event="event"
          force-desktop
        />

        <AppShowCompetitionTagExplanations :competitions="event.competitions" />

        <EventLimits ref="limitModule" :event="event" force-desktop />
      </div>
    </template>
    <div
      v-if="
        !canAdd && !hasNormalCompetitions && !hasCompetitionsForRegistrationOnly
      "
      class="text-center"
    >
      <h3 class="text-secondary">
        {{
          $t(
            "events:EventPage.CompetitionsSectionNoCmpetitions.secondarytext",
            "No competitions",
            "Secondary text for competitions section on event page when no competitions announced"
          )
        }}
      </h3>
    </div>
  </v-container>
</template>
<script>
import { defineComponent } from "vue";
import calculateCompetitionDays from "@/utils/competitionDays";
import EventLimits from "@/components/event/EventLimits.vue";
import EventRegistrationsLimited from "@/components/event/EventRegistrationsLimited.vue";
import EventCompetitions from "@/components/event/competition/EventCompetitions/index.vue";
import AppShowCompetitionTagExplanations from "@AppShows/event/AppShowCompetitionTagExplanations.vue";

export default defineComponent({
  name: "EventCompetitionsManagement",
  components: {
    EventCompetitions,
    EventRegistrationsLimited,
    EventLimits,
    AppShowCompetitionTagExplanations
  },
  props: {
    event: {
      type: Object,
      required: true
    }
  },
  computed: {
    canAdd() {
      return this.$allowedMutation(
        this.event.allowedMutations,
        "eventCompetitionCreateOrUpdate"
      );
    },
    hasCompetitionsForRegistrationOnly() {
      return this.event.competitions.some(c => c.forRegistrationOnly == true);
    },
    hasNormalCompetitions() {
      return this.event.competitions.some(c => !c.forRegistrationOnly);
    },
    competitionsGroupedByDay() {
      const groupedByDays = {};
      this.days.forEach(day => (groupedByDays[day] = []));
      this.event.competitions.forEach(c => {
        if (c.forRegistrationOnly) return;
        // In case some mumbo jumbo competition startDate is not between event's date
        if (!groupedByDays[c.startDate]) groupedByDays[c.startDate] = [];
        groupedByDays[c.startDate].push(c);
      });
      if (this.canAdd) return Object.entries(groupedByDays);
      else return Object.entries(groupedByDays).filter(x => x[1].length > 0);
    },
    // Get all dates from start to end
    days() {
      return calculateCompetitionDays(this.event.startDate, this.event.endDate);
    }
  }
});
</script>
